<template>
  <!-- Adjustment Modal -->
  <transition name="modal">
    <modal :short="true" v-if="show">
      <template slot="modal-header">
        <div class="header-wrapper">
          <h2>Adjustments for {{ campaign.displayName }}</h2>
        </div>
      </template>
      <template slot="modal-body">
        <div class="p-3">
          <vue-good-table :columns="columns" :rows="adjustments">
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.label === 'Delete'">
                <a href="#" @click.prevent="handleDelete(props.row)">Delete</a>
              </span>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>

          <form @submit.prevent="handleSubmit()" class="mt-4">
            <div
              style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px;"
            >
              <div
                style="display: flex;flex-direction: column;justify-content: end;"
              >
                <div class="form-group" style="width: 100%;">
                  <div class="date-time-picker-container inline">
                    <DateTimePicker
                      color="#13a3eb"
                      class="adjustment-date-picker"
                      label="Select Date"
                      formatted="DD MMM YYYY"
                      format="YYYY-MM-DD"
                      id="adjustment-date-picker"
                      autoClose
                      hint="Selected Date"
                      input-size="sm"
                      noClearButton
                      noButton
                      :no-value-to-custom-elem="false"
                      only-date
                      v-model="date"
                    >
                    </DateTimePicker>
                  </div>
                  <label for="adjustment-date-picker"
                    ><span style="color: red;">*</span> Adjustment Date</label
                  >
                </div>
              </div>
              <div>
                <div class="form-group" style="width: 100%;">
                  <select class="form-control" v-model="label">
                    <option value="" disabled>Select Label</option>
                    <option
                      v-for="dropdown in labelDropdown"
                      :value="dropdown"
                      :key="dropdown"
                      >{{ dropdown }}</option
                    >
                  </select>
                  <label for="adjustment-label"
                    ><span style="color: red;">*</span> Label</label
                  >
                </div>
              </div>
              <div>
                <div class="form-group" style="width: 100%;">
                  <input
                    type="number"
                    class="form-control"
                    name="adjustment-amount"
                    id="adjustment-amount"
                    required
                    placeholder="x,xxx.xx"
                    step=".01"
                    v-model="amount"
                  />
                  <label for="adjustment-amount"
                    ><span style="color: red;">*</span> Amount</label
                  >
                </div>
              </div>
              <div>
                <div class="form-group" style="width: 100%;">
                  <input
                    type="text"
                    class="form-control"
                    name="adjustment-remark"
                    id="adjustment-remark"
                    placeholder="Remarks"
                    v-model="remarks"
                  />
                  <label for="adjustment-remark">Remarks</label>
                </div>
              </div>
            </div>
            <div
              style="display: flex; align-items: center; justify-content: space-between; margin-top: 384px;"
            >
              <button
                class="btn btn-quaternary"
                type="button"
                @click="handleClose()"
              >
                Close
              </button>
              <button
                class="btn btn-primary"
                type="submit"
                :disabled="disableSubmit"
              >
                Add
              </button>
            </div>
          </form>
        </div>
      </template>
    </modal>
  </transition>
</template>

<script>
import DateTimePicker from 'vue-ctk-date-time-picker';
import Modal from '../../helpers/Modal';
import {VueGoodTable} from 'vue-good-table';
import CampaignServiceV2 from '../../services/V2/CampaignServiceV2';
import CampaignAdjustmentServiceV2 from '../../services/V2/CampaignAdjustmentServiceV2';
import ApiCallMixin from '../../mixins/ApiCallMixin';
import {mounted} from 'vue2-dropzone';

export default {
  props: ['show', 'campaign'],
  mixins: [ApiCallMixin],
  data() {
    return {
      date: null,
      label: '',
      amount: null,
      remarks: null,
      columns: [
        {
          label: 'Date',
          field: 'adjustmentDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'dd MMM yyyy',
        },
        {
          label: 'Label',
          field: 'label',
        },
        {
          label: 'Amount',
          field: 'amount',
          formatFn: (val) => parseFloat(val).toFixed(2),
        },
        {
          label: 'Remarks',
          field: 'remarks',
        },
        {
          label: 'Delete',
          field: '---',
        },
      ],
      adjustments: [],
      labelDropdown: ['Revenue - ex. GST', 'TTV - ex. GST'],
    };
  },
  components: {
    DateTimePicker,
    Modal,
    VueGoodTable,
  },
  methods: {
    async handleSubmit() {
      const payload = {
        date: this.date,
        label: this.label,
        amount: this.amount,
        remarks: this.remarks,
      };

      const response = await CampaignAdjustmentServiceV2.createCampaignAdjustment(
        this.campaign.id,
        payload
      );

      if (response.status === 201) {
        await this.getAdjustments();
        this.$swal({
          type: 'success',
          title: 'Adjustment Added',
          text: 'Adjustment added successfully!',
        });
        this.resetForm();
      }
    },
    async getAdjustments() {
      const response = await this.request(
        'GET-ADJUSTMENTS',
        CampaignAdjustmentServiceV2.getCampaignAdjustments,
        this.campaign.id
      );
      if (response.status === 200) {
        this.adjustments = response.data.data;
      }
    },
    async handleDelete(adjustment) {
      const confirm = await this.$swal({
        type: 'warning',
        title: 'Confirm Delete',
        text: 'Are you sure you want to delete this adjustment entry?',
        showCancelButton: true,
      });

      if (confirm && confirm.dismiss) {
        return;
      }

      const response = await CampaignAdjustmentServiceV2.deleteCampaignAdjustments(
        adjustment.id
      );

      if (response && response.status === 204) {
        this.$swal({
          type: 'success',
          title: 'Adjustment deleted',
          text: 'Adjustment has been deleted successfully',
        });
        await this.getAdjustments();
      }
    },
    resetForm() {
      this.date = null;
      this.label = '';
      this.amount = null;
      this.remarks = null;
    },
    handleClose() {
      this.resetForm();
      this.$emit('on-close-clicked');
    },
  },
  computed: {
    disableSubmit() {
      return !this.date || !this.label || !this.amount;
    },
  },
  watch: {
    async campaign(value) {
      if (value && value.id) {
        await this.getAdjustments();
      }
    },
  },
  mounted() {
    this.registerApis(['GET-ADJUSTMENTS']);
  },
};
</script>
